import { createRouter, createWebHistory } from "vue-router";
import useGolfSamsungNavigation from "@/composables/useGolfsamsungNavigation";
import { useStore } from "vuex";
import Logger from "@/utils/Logger";
import RouteNames from "@/router/RouteNames";
import useModal from "@/composables/useModal";

const routes = [
  {
    path: "/gooduser",
    component: () => import("@/components/layouts/DefaultLayout.vue"),
    children: [
      {
        path: "",
        name: RouteNames.MainView,
        component: () => import("@/views/main/MainView.vue"),
        meta: {
          header: {
            className: "type-main",
          },
        },
      },
      {
        path: "",
        component: () =>
          import("@/components/layouts/GenderCategoriesLayout.vue"),
        children: [
          {
            path: "men-categories",
            name: RouteNames.MenCategoriesView,
            component: () => import("@/views/etc/GenderCategoriesView.vue"),
            meta: {
              header: {
                className: "type_view",
                title: "MEN",
              },
            },
            props: {
              genderType: "M",
            },
          },
          {
            path: "women-categories",
            name: RouteNames.WomenCategoriesView,
            component: () => import("@/views/etc/GenderCategoriesView.vue"),
            meta: {
              header: {
                className: "type_view",
                title: "WOMEN",
              },
            },
            props: {
              genderType: "W",
            },
          },
        ],
      },
      {
        path: "",
        component: () => import("@/components/layouts/PromotionLayout.vue"),
        children: [
          {
            path: "brand-promotion",
            name: RouteNames.BrandPromotionView,
            component: () => import("@/views/promotion/BrandPromotionView.vue"),
            meta: {
              promotion: {
                title: "브랜드",
              },
            },
          },
          {
            path: "best-promotion",
            name: RouteNames.BestPromotionView,
            component: () => import("@/views/promotion/BestPromotionView.vue"),
            meta: {
              promotion: {
                title: "베스트",
              },
            },
          },
          {
            path: "event-promotion",
            name: RouteNames.EventPromotionView,
            component: () => import("@/views/promotion/EventPromotionView.vue"),
            meta: {
              promotion: {
                title: "이벤트",
              },
            },
          },
          {
            path: "golftv-promotion",
            name: RouteNames.GolfTvPromotionView,
            component: () =>
              import("@/views/promotion/GolfTvPromotionView.vue"),
            meta: {
              promotion: {
                title: "골프 TV",
              },
            },
          },
        ],
      },
      {
        path: "",
        component: () =>
          import("@/components/layouts/ExhibitionPromotionLayout.vue"),
        children: [
          {
            path: "exhibition-promotion",
            name: RouteNames.ExhibitionPromotionView,
            component: () =>
              import("@/views/promotion/ExhibitionPromotionView.vue"),
          },
          {
            path: "hot-tag-exhibition-promotion",
            name: RouteNames.HotTagExhibitionPromotionView,
            component: () =>
              import("@/views/promotion/HotTagExhibitionPromotionView.vue"),
            props: (route) => ({ id: Number(route.hash.split("_")[1]) }),
          },
        ],
      },
      {
        path: "",
        component: () => import("@/components/layouts/ContentLayout.vue"),
        children: [
          {
            path: "exhibitions/:id",
            name: RouteNames.ExhibitionDetailsView,
            component: () =>
              import("@/views/promotion/ExhibitionDetailsView.vue"),
            props: (route) => ({ id: Number(route.params.id) }),
          },
          {
            path: "events/:id",
            name: RouteNames.EventDetailsView,
            component: () => import("@/views/promotion/EventDetailsView.vue"),
            props: (route) => ({ id: Number(route.params.id) }),
          },
        ],
      },
      {
        path: "",
        component: () => import("@/components/layouts/ContentLayout.vue"),
        children: [
          {
            path: "brands/:id/products",
            name: RouteNames.BrandProductListView,
            component: () =>
              import("@/views/promotion/BrandProductListView.vue"),
            props: (route) => ({
              visualBrandId: Number(route.params.id),
            }),
          },
          {
            path: "golf-tv-channels/:id/products",
            name: RouteNames.GolfTvCannelProductsView,
            component: () =>
              import("@/views/promotion/GolfTvCannelProductsView.vue"),
            props: (route) => ({ id: Number(route.params.id) }),
          },
        ],
      },
      {
        path: "",
        component: () => import("@/components/layouts/MyPageLayout.vue"),
        children: [
          {
            path: "members/:memberId/shipping-addresses",
            name: "MyShippingAddressView",
            component: () => import("@/views/mypage/MyShippingAddressView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "배송지 관리",
              },
            },
          },
          {
            path: "members/:memberId/update/shipping-addresses/:id?",
            name: "MyShippingAddressWriteForm",
            component: () =>
              import("@/views/mypage/MyShippingAddressWriteForm.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "배송지 관리",
              },
            },
          },
          {
            path: "members/:memberId/notices",
            name: "MyNotificationView",
            component: () => import("@/views/mypage/MyNotificationView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "알림",
              },
              myPage: {
                wrapper: {
                  className: "my_notice",
                },
              },
            },
          },
          {
            path: "members/:memberId/cancellation",
            name: "MyCancellationView",
            component: () => import("@/views/mypage/MyCancellationView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "취소 내역",
              },
            },
          },
          {
            path: "my-page",
            name: "MyPageDashboardView",
            component: () => import("@/views/mypage/MyPageDashboardView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "MY 굿샵",
              },
              myPage: {
                className: "mob",
              },
            },
          },
          {
            path: "members/:memberId/orders",
            name: "MyOrderHistoryView",
            component: () => import("@/views/mypage/MyOrderHistoryView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "주문 배송 조회",
              },
            },
          },
          {
            path: "members/:memberId/orders/:id",
            name: "MyOrderDetailView",
            component: () => import("@/views/mypage/MyOrderDetailView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "주문 상세 정보",
              },
            },
          },
          {
            path: "my-page/gifts",
            name: "MyGiftBoxView",
            component: () => import("@/views/mypage/MyGiftBoxView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "My 선물함",
              },
              myPage: {
                className: "mob",
              },
            },
          },
          {
            path: "members/:memberId/qnas",
            name: "QnaListView",
            component: () => import("@/views/mypage/QnaListView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "상품 Q&A",
              },
            },
          },
          {
            path: "members/:memberId/register-recommend-user",
            name: "MyRecommendUserView",
            component: () => import("@/views/mypage/MyRecommendUserView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "나의 추천인 등록",
              },
            },
          },
          {
            path: "members/:memberId/restock-notifications",
            name: "RestockNotificationView",
            component: () =>
              import("@/views/mypage/RestockNotificationView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "재입고 알림",
              },
            },
          },
          {
            path: "members/:memberId/reviews",
            name: "ReviewListView",
            component: () => import("@/views/mypage/ReviewListView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "나의 리뷰",
              },
            },
          },
          {
            path: "members/:memberId/review-histories",
            name: "ReviewHistoryView",
            component: () => import("@/views/mypage/ReviewHistoryView.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "나의 리뷰",
              },
            },
          },
          {
            path: "my-page/wish-product",
            name: "ProductWishList",
            component: () => import("@/views/mypage/ProductWishList.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "찜리스트",
              },
              myPage: {
                className: "mob",
              },
            },
          },
          {
            path: "member/wish-brands",
            name: "BrandWishList",
            component: () => import("@/views/mypage/BrandWishList.vue"),
            meta: {
              requiresAuth: true,
              header: {
                className: "type_view",
                title: "찜리스트",
              },
              myPage: {
                className: "mob",
              },
            },
          },
        ],
      },
      {
        path: "tcs",
        component: () =>
          import("@/components/layouts/CustomerCenterLayout.vue"),
        children: [
          {
            path: "notices",
            name: RouteNames.NoticeListView,
            component: () =>
              import("@/views/customercenter/NoticeListView.vue"),
            meta: {
              header: {
                className: "type_view",
                title: "공지사항",
              },
            },
          },
          {
            path: "notices/:id",
            name: RouteNames.NoticeDetailsView,
            component: () =>
              import("@/views/customercenter/NoticeDetailsView.vue"),
            props: (route) => ({ id: Number(route.params.id) }),
            meta: {
              header: {
                className: "type_view",
                title: "공지사항",
              },
            },
          },
          {
            path: "alliance",
            name: RouteNames.AllianceAndQnaView,
            component: () =>
              import("@/views/customercenter/AllianceAndQnaView.vue"),
            meta: {
              header: {
                className: "type_view",
                title: "제휴 및 입점문의",
              },
            },
          },
          {
            path: "faqs",
            name: RouteNames.FaqListView,
            component: () => import("@/views/customercenter/FaqListView.vue"),
            meta: {
              header: {
                className: "type_view",
                title: "FAQ",
              },
            },
          },
          {
            path: "faqs/:id",
            name: RouteNames.FaqDetailsView,
            component: () =>
              import("@/views/customercenter/FaqDetailsView.vue"),
            props: (route) => ({ id: Number(route.params.id) }),
            meta: {
              header: {
                className: "type_view",
                title: "FAQ",
              },
            },
          },
        ],
      },
      {
        path: "policies/service",
        name: RouteNames.ServicePolicyView,
        component: () => import("@/views/policy/ServicePolicyView.vue"),
        meta: {
          header: {
            className: "type_view",
            title: "이용약관",
          },
        },
      },
      {
        path: "",
        component: () => import("@/components/layouts/ContentLayout.vue"),
        children: [
          {
            path: "search",
            name: RouteNames.SearchResultView,
            component: () => import("@/views/product/SearchResultView.vue"),
            meta: {
              header: {
                className: "type-goods-list",
              },
            },
          },
          {
            path: "men-products",
            name: RouteNames.MenProductListView,
            component: () =>
              import("@/views/product/GenderProductListView.vue"),
            meta: {
              header: {
                className: "type-goods-list",
              },
            },
            props: {
              genderType: "M",
            },
          },
          {
            path: "women-products",
            name: RouteNames.WomenProductListView,
            component: () =>
              import("@/views/product/GenderProductListView.vue"),
            meta: {
              header: {
                className: "type-goods-list",
              },
            },
            props: {
              genderType: "F",
            },
          },
          {
            path: "golf-products",
            name: RouteNames.GolfProductListView,
            component: () => import("@/views/product/GolfProductListView.vue"),
            meta: {
              header: {
                className: "type-goods-list",
              },
            },
          },
          {
            path: "living-products",
            name: RouteNames.LivingProductListView,
            component: () =>
              import("@/views/product/LivingProductListView.vue"),
            meta: {
              header: {
                className: "type-goods-list",
              },
            },
          },
          {
            path: "attendance-event",
            name: RouteNames.AttendanceEvent,
            component: () =>
              import("@/views/attendance/AttendanceEventView.vue"),
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "products",
        component: () => import("@/components/layouts/ContentLayout.vue"),
        children: [
          {
            path: ":id",
            name: RouteNames.ProductDetailsView,
            component: () => import("@/views/product/ProductDetailsView.vue"),
            meta: {
              header: {
                className: "type-goods-list",
              },
            },
            props: (route) => ({ id: Number(route.params.id) }),
          },
        ],
      },
      {
        path: "",
        component: () => import("@/components/layouts/OrderLayout.vue"),
        children: [
          {
            path: "cart",
            name: RouteNames.CartView,
            component: () => import("@/views/cart/CartView.vue"),
            meta: {
              requiresAuth: true,
              footer: {
                className: "for-cart-m",
              },
            },
          },
          {
            path: "orders/present",
            name: RouteNames.OrderToPresentView,
            component: () => import("@/views/order/OrderToPresentView.vue"),
            meta: {
              requiresAuth: true,
              footer: {
                className: "for-cart-m",
              },
            },
          },
          {
            path: "orders/buy-now",
            name: RouteNames.OrderToBuyNowView,
            component: () => import("@/views/order/OrderToBuyNowView.vue"),
            meta: {
              requiresAuth: true,
              footer: {
                className: "for-cart-m",
              },
            },
          },
          {
            path: "orders/buy-in-cart",
            name: RouteNames.OrderInCartView,
            component: () => import("@/views/order/OrderInCartView.vue"),
            meta: {
              requiresAuth: true,
              footer: {
                className: "for-cart-m",
              },
            },
          },
          {
            path: "order-complete",
            name: RouteNames.OrderCompleteView,
            component: () => import("@/views/order/OrderCompleteView.vue"),
            meta: {
              requiresAuth: true,
            },
            props: (route) => ({ id: route.query.id }),
          },
        ],
      },
    ],
  },
  {
    path: "/gooduser/gifts/input-certification-number",
    name: "GiftCertificationForm",
    component: () => import("@/views/gift/GiftCertificationForm.vue"),
  },
  {
    path: "/gooduser/gifts/refuse-gift",
    name: "GiftRefuseForm",
    component: () => import("@/views/gift/GiftRefuseForm.vue"),
  },
  {
    path: "/gooduser/auth/golf-samsung-callback",
    name: "GolfSamsungLoginCallback",
    component: () => import("@/views/etc/LoginCallback.vue"), // 동적 import
    props: (route) => ({ token: route.query.userId }),
  },
  //FIXME gift 관련 path 옛날거라 지워야됨.
  {
    path: "/gooduser/gift/giftCert",
    redirect: {
      name: "GiftCertificationForm",
    },
  },
  //FIXME gift 관련 path 옛날거라 지워야됨.
  {
    path: "/gooduser/gift/giftRefuse",
    redirect: {
      name: "GiftRefuseForm",
    },
  },
  // TODO 관리자 상품 미리보기 때문에 링크 보존 (추후 삭제)
  {
    path: "/gooduser/goodslist/detail/:id",
    redirect: (to) => ({
      name: RouteNames.ProductDetailsView,
      params: {
        id: to.params.id,
      },
    }),
  },
  // TODO 서버 구소스 링크 때문에 보존 (추후 삭제)
  {
    path: "/gooduser/cartview/orderfinish/:id",
    redirect: (route) => ({
      name: RouteNames.OrderCompleteView,
      query: {
        id: route.params.id,
      },
    }),
  },
  // TODO 추후 삭제
  {
    path: "/gooduser/promotion/eventdetail/:id",
    redirect: (to) => ({
      name: RouteNames.EventDetailsView,
      params: {
        id: to.params.id,
      },
    }),
  },
  // TODO 서버 구소스 링크 때문에 보존 (추후 삭제)
  {
    path: "/gooduser/cartview/productorder/P",
    redirect: {
      name: RouteNames.OrderToPresentView,
    },
  },
  // TODO 서버 구소스 링크 때문에 보존 (추후 삭제)
  {
    path: "/gooduser/cartview/productorder/Y",
    redirect: {
      name: RouteNames.OrderInCartView,
    },
  },
  // TODO 서버 구소스 링크 때문에 보존 (추후 삭제)
  {
    path: "/gooduser/cartview/productorder/N",
    redirect: {
      name: RouteNames.OrderToBuyNowView,
    },
  },
  // TODO 추후 삭제
  {
    path: "/gooduser/callback",
    redirect: {
      name: "GolfSamsungLoginCallback",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "NotFound" },
  },
  {
    path: "/gooduser/404",
    name: "NotFound",
    component: () => import("@/views/etc/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      let stack = 0;
      let intervalEvent = function () {
        if (stack === 0) {
          window.scrollTo({ top: savedPosition.top });
        }
        if (stack > 100) {
          clearInterval(intervalTarget);
          window.scrollTo({ top: savedPosition.top });
        }
        if (
          document.body.scrollHeight - window.innerHeight >
          savedPosition.top
        ) {
          clearInterval(intervalTarget);
          window.scrollTo({ top: savedPosition.top });
        }
        stack++;
      };

      let intervalTarget = setInterval(() => {
        intervalEvent();
      }, 100);
    } else {
      window.scrollTo({ top: 0 });
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from) => {
  if (to.name === RouteNames.MainView && from.name === RouteNames.MainView) {
    return false;
  }
  const store = useStore();
  const { alert } = useModal();

  store.commit("setLoading", true);
  store.commit("setVisibleAllCategories", false);
  store.commit("setVisibleMobileSearchTab", false);

  // load session user
  await store.dispatch("loadSessionUser");

  const hasAuth = !!store.getters.userId;
  const auth = !!to.meta?.requiresAuth || false;
  if (auth && !hasAuth) {
    if (to.name === RouteNames.AttendanceEvent) {
      sessionStorage.setItem("lastRouteName", to.name);
    }
    await alert("로그인이 필요한 페이지 입니다.");
    useGolfSamsungNavigation().navigateLoginPage();
    return false;
  }

  try {
    const promises = [
      store.dispatch("loadHotTags"),
      store.dispatch("loadCategories"),
      store.dispatch("loadTopSearchKeywords"),
    ];
    if (hasAuth) {
      promises.concat([
        store.dispatch("loadBags"),
        store.dispatch("loadTotalFavorites"),
      ]);
    }

    await Promise.all(promises);
  } catch (e) {
    Logger.error(e);
  }

  return true;
});

router.afterEach(() => {
  const store = useStore();

  store.commit("setLoading", false);
});

export default router;
